<div
  class="row pb-5"
  [hidden]="
    !didSelectorFormData ||
    !didSelectorFormData.webexCallingLicense ||
    didSelectorFormData.webexCallingLicense === UCM_LICENSE_NAME
  "
>
  <div class="col-md-12 order-2 order-md-1">
    <ziro-fieldset-header [legend]="'tkey;helpdesk.webex_calling.extension_details.header'">
      <ziro-text [fieldId]="'extension'"></ziro-text>
    </ziro-fieldset-header>
  </div>
</div>
